var router = require('pjax').Router;
var index = require('./index.js');
var pick = require('./pick.js');
var slideshow = require('./slideshow.js');

router.get('entry/pick/([a-zA-Z]+)/([a-zA-Z]+)', pick);
router.get('entry/pick/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
router.get('entry/pick', index);
